import React from 'react'
import { Spinner } from '@shopify/polaris'

class SpinnerEffect extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      spinner: this.props.spinner
    }
  }
  
  render() {
    if (this.props.spinner === true ) {
      return <Spinner accessibilityLabel="Spinner example" size="large" />
    } return null
  }
} 
 
export default SpinnerEffect